import {
  getDepartments,
  getGroups,
  getPermissionTags,
} from '@vlabs/api/artemy/client';
import type {
  DepartmentRecord,
  GroupRecord,
  PermissionTagRecord,
} from '@vlabs/api/artemy/model';

export interface SourceGroupOption {
  label: string;
  value: string;
}

export const OPTIONS_PAGE_SIZE = 1000;

/** Общий хвост загрузчиков опций: пустые значения и сортировка по label. */
export function toSourceGroupOptions<T extends { label: string; value: string }>(options: T[]): T[] {
  return options
    .filter(({ value }) => value !== '')
    .sort((left, right) => left.label.localeCompare(right.label));
}

export async function loadDepartmentOptions(): Promise<SourceGroupOption[]> {
  const { departments } = await getDepartments({ page: 1, page_size: OPTIONS_PAGE_SIZE });

  return toSourceGroupOptions((departments ?? []).map(
    (department: DepartmentRecord): SourceGroupOption => ({
      label: department.name ?? department.department_id ?? '',
      value: department.department_id ?? '',
    }),
  ));
}

export async function loadPermissionTagOptions(): Promise<SourceGroupOption[]> {
  const { permission_tags: permissionTags } = await getPermissionTags({
    page: 1,
    page_size: OPTIONS_PAGE_SIZE,
  });

  return toSourceGroupOptions((permissionTags ?? []).map(
    (tag: PermissionTagRecord): SourceGroupOption => ({
      label: tag.permission_tag ?? '',
      value: tag.permission_tag ?? '',
    }),
  ));
}

export async function loadGroupOptions(): Promise<SourceGroupOption[]> {
  const { groups } = await getGroups({ page: 1, page_size: OPTIONS_PAGE_SIZE });

  return toSourceGroupOptions((groups ?? []).map(
    (group: GroupRecord): SourceGroupOption => ({
      label: group.group_name ?? group.group_id ?? '',
      value: group.group_id ?? '',
    }),
  ));
}
